import { Component, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Observable } from 'rxjs';
import { ListResult } from '../../../api/core/list-result';
import { LookupItem } from '../../../api/data-model';
import { LookupService } from '../../../services/service';
import { BasePickerComponent } from './base-picker.component';

@Component({
  selector: 'app-progress-status-picker',
  standalone: true,
  imports: [FormsModule, AutoCompleteModule],
  templateUrl: './base-picker.component.html',
  providers: [
    LookupService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProgressStatusPickerComponent),
      multi: true,
    },
  ],
})
export class ProgressStatusPickerComponent extends BasePickerComponent<LookupItem> {
  constructor(private readonly lookupService: LookupService) {
    super();
  }

  override search(query: string): Observable<ListResult<LookupItem>> {
    return this.lookupService.getProgressStatuses(undefined, query, 100);
  }

  override load(keys: string[]): Observable<ListResult<any>> {
    return this.lookupService.getProgressStatuses(keys,undefined,100);
  }
}
